import { Pipe, PipeTransform } from '@angular/core';
import { decimalsToCents } from '@web/dtos';

@Pipe({
  name: 'decimalsToCents',
  standalone: true,
})
export class DecimalsToCentsPipe implements PipeTransform {
  transform(value: number): number {
    return decimalsToCents(value);
  }
}
